import React from 'react';

import { images } from '../../constants';

const SubHeading = ({title}) => (
  <div style={{marginBottom: '1rem', fontSize:"2rem", color: '#fff'}}>
    <p className='p__Cormorant'>{title}</p>
  </div>
);

export default SubHeading;
